import { Analysis, PossibleRootCauseCategory } from '.';

export class KidneyAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.bun.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7000);
        } else if (this.ba.bun.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7010);
        }

        if (this.ba.creatinine.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7020);
        } else if (this.ba.creatinine.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7030);
        }

        if (this.ba.eGFR.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7050);
        }

        if (this.ba.bunCreatinineRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7060);
        } else if (this.ba.bunCreatinineRatio.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7070);
        }

        if (this.ba.uricAcid.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7080);
        } else if (this.ba.uricAcid.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_7090);
        }
    }
}